<template>
  <LayoutContainer :props="props">
    <div class="red-packet-card">
      <div class="flex-center card-header">
        <span class="card-title">我的红包</span>
        <div class="flex-center show-all" @click="showAll" v-if="$store.state.share.homeInfo.activityId">
          <span>查看往期记录</span>
          <img class="icon-back" src="~@/assets/back-dark-icon.png" />
        </div>
      </div>

      <van-row type="flex" align="center" class="card-body">
        <van-col span="8" class="body-item">
          <div>
            <span class="money">{{ detail.onTheWay || 0 }}</span>
            元
          </div>
          <div class="flex-center jcc">
            <span class="text">本期在路上</span>
            <PopoverComponent>
              <div>{{ props.popover }}</div>
            </PopoverComponent>
          </div>
        </van-col>
        <van-col span="8" class="body-item">
          <div>
            <span class="money">{{ detail.waitGrantAmount || 0 }}</span>
            元
          </div>
          <div>
            <span class="text">本期待到账</span>
          </div>
        </van-col>
        <van-col span="8" class="body-item">
          <div>
            <span class="money">{{ detail.grantedAmount || 0 }}</span>
            元
          </div>
          <div>
            <span class="text">本期已获得</span>
          </div>
        </van-col>
      </van-row>
    </div>
  </LayoutContainer>
</template>

<script>
import { mapState } from 'vuex';
import { openUrl } from '@/utils/utils';
import PopoverComponent from '@/components/popover';
import { inviteAwardTotalDetail } from '@/api';

export default {
  name: 'kaer-redpacket-card',
  components: {
    PopoverComponent
  },
  props: {
    componentId: String,
    props: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      clickTrackId: '',
      detail: {}
    };
  },
  computed: {
    ...mapState({
      homeInfo: (state) => state.share.homeInfo,
      pageData: (state) => state.share.pageData
    })
  },
  created() {
    if (this.adapt.isLogin()) {
      this.getDetail();
    }
  },
  methods: {
    async showAll() {
      this.uploadData(this.$teleCodes.clickAllreward, 'event', { kaerComponentId: this.componentId });

      await this.adapt.login();

      // 根据是否存在邀请人信息判断是否登录
      if (!this.homeInfo.inviterUserId) {
        await this.adapt.reLogin();
        return;
      }

      if (this.props.url) {
        openUrl(this.url);
      } else {
        this.$router.push({
          name: 'MyReward',
          query: {
            activityId: this.pageData.activityId,
            ...this.$route.query,
            activityType: this.$store.state.share.homeInfo.activityType
          }
        });
      }
    },
    async getDetail() {
      const req = {
        bizId: 'C_TERMINAL',
        activityPeriodType: 0,
        activityId: this.pageData.activityId,
        activityType: this.$store.state.share.homeInfo.activityType
      };
      const res = await inviteAwardTotalDetail(req);
      this.detail = res;
    }
  }
};
</script>

<style scoped lang="less">
.red-packet-card {
  width: 100%;
  border-radius: 8px;
  background: #fff;

  .card-header {
    background: #f5f5f5;
    height: 40px;
    padding: 0 12px;
    border-radius: 8px 8px 0px 0px;
    justify-content: space-between;

    .card-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #595959;
    }

    .show-all {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #595959;
    }

    .icon-back {
      width: 10px;
      transform: rotate(-180deg);
    }
  }

  .card-body {
    border-radius: 0px 0px 8px 8px;
    height: 80px;

    .body-item {
      flex-grow: 1;
      text-align: center;
      font-size: 12px;

      .money {
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262626;
        margin-right: 4px;
      }

      .text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #8c8c8c;
      }
    }
  }
}
</style>
